import React, { useState } from "react";
import SlotPickerModal from "../WeeklyPlan/SlotPickerModal";
import { resolveActivityFullDayPlanSlot } from "../../lib/activityPlanSlot";
import { FULL_DAY_CANONICAL_HOUR } from "../../lib/planBuckets";
import { isPlanRefOnDay } from "../../lib/planSlotRefs";

export default function AddToPlanButton({
  columnId,
  eventId,
  onAddToSlot,
  variant = "default",
  /** Card/event row; used with planDayDates for automatic slot from date + time */
  activity = null,
  /** From useWeeklyPlan — required for automatic placement */
  planDayDates = null,
  /** From useWeeklyPlan — with getSlotKey, duplicate on auto-day opens day picker instead */
  planSlots = null,
  getSlotKey = null,
}) {
  const [showSlotPicker, setShowSlotPicker] = useState(false);

  const tryAutoSlot = () => {
    if (!Array.isArray(planDayDates) || planDayDates.length === 0 || !activity) {
      return null;
    }
    return resolveActivityFullDayPlanSlot(activity, planDayDates);
  };

  const handleClick = (e) => {
    e.stopPropagation();
    const ref = { columnId, eventId };
    const slot = tryAutoSlot();
    if (slot) {
      if (
        planSlots &&
        getSlotKey &&
        isPlanRefOnDay(planSlots, slot.day, getSlotKey, ref)
      ) {
        setShowSlotPicker(true);
        return;
      }
      onAddToSlot(slot.day, slot.hour, ref);
      return;
    }
    setShowSlotPicker(true);
  };

  const handleSlotSelect = (day) => {
    onAddToSlot(day, FULL_DAY_CANONICAL_HOUR, { columnId, eventId });
    setShowSlotPicker(false);
  };

  const isCompact = variant === "compact";

  return (
    <>
      <button
        type="button"
        className={`add-to-plan-btn ${isCompact ? "add-to-plan-btn-compact" : ""}`}
        onClick={handleClick}
        aria-label="Zum Plan hinzufügen"
      >
        <span className="add-to-plan-btn-icon" aria-hidden="true">
          +
        </span>
        {!isCompact && <span className="add-to-plan-btn-label">Zum Plan hinzufügen</span>}
      </button>
      {showSlotPicker && (
        <SlotPickerModal
          onSelect={handleSlotSelect}
          onClose={() => setShowSlotPicker(false)}
        />
      )}
    </>
  );
}
